module.exports = __webpack_public_path__ + "img/slotmachine_free.bf5333ba.png";